/**
 * Show and hide header navigation
 */
$('.js-hamburger').on('click', function(event) {
	event.preventDefault();
	
	$(this).toggleClass('hamburger--toggle');
	$('.js-nav').slideToggle()
});